export default {"src":"/stays/_next/static/media/payments.f7e65493.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};